/**
 * ----------------------------------------------------------------------------------------------
 * individual JS for Shoplist Page
 * ----------------------------------------------------------------------------------------------
 */

// タブ切り替え関数
const tabSwitch = (_this,_target_id)=>{
  document.querySelector('.c-tab.is-active').classList.remove('is-active');
  _this.classList.add('is-active');
  document.querySelector('.c-content.is-show').classList.remove('is-show');
  document.getElementById(_target_id).classList.add('is-show');
};

// URLパラメータからタブを切り替え
const initTabFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const tab = urlParams.get('tab');
  
  if (tab === 'veilance') {
    const veilanceTab = document.querySelector('.c-tab[onclick*="c-content-veilance"]');
    if (veilanceTab && !veilanceTab.classList.contains('is-active')) {
      tabSwitch(veilanceTab, 'c-content-veilance');
    }
  }
};

// Shoplist検索用
let typingTimer;               
let typeInterval = 500; 
let fetch_shop_data_outdoor = [],
  fetch_shop_data_veilance = [];

// Map用ポップアップ表示
const openMapPopup = (e,_data_line,_category) => {
  e.preventDefault();

  let shop_data = {};
  if(_category === "VEILANCE"){
    // カテゴリー：VEILANCE
    shop_data = fetch_shop_data_veilance.find(data => data.データ番号 === _data_line);
  }else{
    // カテゴリー：OUTDOOR,OUTDOOR_VEILANCE
    shop_data = fetch_shop_data_outdoor.find(data => data.データ番号 === _data_line);
  }
  
  if(shop_data){
    // 店舗情報が取得できた場合(できるはず)
    const popup = document.querySelector('.c-map-popup');
    const close_btn = document.querySelector('.c-map-popup__close');
    const overlay = document.querySelector('.c-map-popup__overlay');
    popup.classList.add('active');
    overlay.classList.add('active');

    // ポップアップのレンダリング
    document.querySelector('.c-map-popup__iframe-wrapper').innerHTML = shop_data.GoogleMap_埋め込み;
    document.querySelector('.c-map-popup__shop-desc').innerHTML = `
      <h4 class="c-result-shopname__title">${shop_data.店名}</h4>
      <div class="c-result-shopdesc__content">
          <div class="c-result-shopdesc__content-desc">
            <p>${shop_data.住所.charAt(0) === "〒" ? shop_data.住所.replace(" ","<br/>") : shop_data.住所}</p>
            <p>${shop_data.電話番号}</p>
            ${shop_data.営業時間 ? `<p>営業時間：${shop_data.営業時間}</p>` : ""}
          </div>
      </div>

      ${shop_data.インスタ ? `
        <div class="c-result-shopname__social-media">
          <a href="${shop_data.インスタ}" target="_blank" rel="noopener noreferrer">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-instagram" viewBox="0 0 512 512"><path d="M256 49.5c67.3 0 75.2.3 101.8 1.5 24.6 1.1 37.9 5.2 46.8 8.7 11.8 4.6 20.2 10 29 18.8s14.3 17.2 18.8 29c3.4 8.9 7.6 22.2 8.7 46.8 1.2 26.6 1.5 34.5 1.5 101.8s-.3 75.2-1.5 101.8c-1.1 24.6-5.2 37.9-8.7 46.8-4.6 11.8-10 20.2-18.8 29s-17.2 14.3-29 18.8c-8.9 3.4-22.2 7.6-46.8 8.7-26.6 1.2-34.5 1.5-101.8 1.5s-75.2-.3-101.8-1.5c-24.6-1.1-37.9-5.2-46.8-8.7-11.8-4.6-20.2-10-29-18.8s-14.3-17.2-18.8-29c-3.4-8.9-7.6-22.2-8.7-46.8-1.2-26.6-1.5-34.5-1.5-101.8s.3-75.2 1.5-101.8c1.1-24.6 5.2-37.9 8.7-46.8 4.6-11.8 10-20.2 18.8-29s17.2-14.3 29-18.8c8.9-3.4 22.2-7.6 46.8-8.7 26.6-1.3 34.5-1.5 101.8-1.5m0-45.4c-68.4 0-77 .3-103.9 1.5C125.3 6.8 107 11.1 91 17.3c-16.6 6.4-30.6 15.1-44.6 29.1-14 14-22.6 28.1-29.1 44.6-6.2 16-10.5 34.3-11.7 61.2C4.4 179 4.1 187.6 4.1 256s.3 77 1.5 103.9c1.2 26.8 5.5 45.1 11.7 61.2 6.4 16.6 15.1 30.6 29.1 44.6 14 14 28.1 22.6 44.6 29.1 16 6.2 34.3 10.5 61.2 11.7 26.9 1.2 35.4 1.5 103.9 1.5s77-.3 103.9-1.5c26.8-1.2 45.1-5.5 61.2-11.7 16.6-6.4 30.6-15.1 44.6-29.1 14-14 22.6-28.1 29.1-44.6 6.2-16 10.5-34.3 11.7-61.2 1.2-26.9 1.5-35.4 1.5-103.9s-.3-77-1.5-103.9c-1.2-26.8-5.5-45.1-11.7-61.2-6.4-16.6-15.1-30.6-29.1-44.6-14-14-28.1-22.6-44.6-29.1-16-6.2-34.3-10.5-61.2-11.7-27-1.1-35.6-1.4-104-1.4z"/><path d="M256 126.6c-71.4 0-129.4 57.9-129.4 129.4s58 129.4 129.4 129.4 129.4-58 129.4-129.4-58-129.4-129.4-129.4zm0 213.4c-46.4 0-84-37.6-84-84s37.6-84 84-84 84 37.6 84 84-37.6 84-84 84z"/><circle cx="390.5" cy="121.5" r="30.2"/></svg>
          </a>
        </div>
      ` : ""}
      ${shop_data.アクティビティ_1 || shop_data.アクティビティ_2 ? `
        <div class="c-result-shopname__activity">
            <span>取り扱い有り</span>
            ${shop_data.アクティビティ_1 ? `<svg class="icon" enable-background="new 0 0 56.69 47.9" viewBox="0 0 56.69 47.9" xmlns="http://www.w3.org/2000/svg"><path d="m45.04 24.91-6.1-14.61c.85.19 1.64.28 2.36.29 1.3.7 5.25 2.81 7.45 3.62.86.32 1.54.51 2.15.51.79 0 1.44-.34 2.18-1.17.53-.61 2.16-2.46.44-4.23-1.54-1.59-5.47-5.2-7.16-6.74-.08-.84-.19-1.62-.33-2.19-.59-1.22-5.11.72-7.21 1.7-1.54.72-9.04.94-10.47.94-1.43.01-8.94-.22-10.47-.94-2.1-.98-6.62-2.92-7.21-1.7-.13.57-.24 1.35-.33 2.19-1.69 1.54-5.62 5.15-7.16 6.74-1.71 1.77-.09 3.62.44 4.23.73.84 1.38 1.17 2.18 1.17.6 0 1.28-.19 2.15-.51 2.2-.82 6.15-2.92 7.45-3.62.72 0 1.51-.09 2.36-.29l-6.1 14.61c-7.2.67-11.62 4.92-11.66 12.02-.04 6.52 5.43 11.05 11.98 10.97 3.73-.05 7.03-1.62 9.18-4.05-.01.01-.02.03-.04.04 6.18-5.73 3.93-13.33-1.55-16.95l8.77-7.7 8.77 7.7c-5.48 3.62-7.73 11.21-1.55 16.95-.01-.01-.02-.03-.04-.04 2.14 2.42 5.45 4 9.18 4.05 6.55.08 12.02-4.45 11.98-10.97-.03-7.1-4.44-11.35-11.64-12.02zm1.41-17.04c.08-.72.1-1.68.07-2.7 1.9 1.75 4.55 4.2 5.71 5.4.28.29.56.58-.5 1.8-.58.66-.68.78-2.35.16-1.38-.51-3.57-1.6-5.25-2.48 1.19-.4 1.94-.95 2.32-2.18zm-39.14 4.66c-1.67.62-1.77.5-2.35-.16-1.07-1.22-.78-1.52-.5-1.8 1.16-1.2 3.8-3.65 5.71-5.4-.03 1.02-.01 1.98.07 2.7.37 1.23 1.13 1.78 2.32 2.18-1.68.88-3.87 1.97-5.25 2.48zm-5.53 19.26c1.93-2.77 5.24-4.7 9.09-4.99l-4.7 11.27c-2.07-1.67-3.61-3.83-4.39-6.28zm21.93 5.39c.01.99-.14 1.96-.41 2.87-2.03.94-4.33 1.48-6.77 1.51-3.27.04-6.29-.85-8.79-2.39l5.17-12.39c6.01.47 10.74 4.92 10.8 10.4zm2.76-18.79-8.65 7.6c-1.27-.57-2.66-.95-4.12-1.07l6.4-15.33c.76-.29 1.53-.63 2.3-1.02 1.54.24 2.87.39 4.07.48zm3.76 0v-9.35c1.2-.08 2.53-.23 4.07-.48.77.39 1.54.74 2.3 1.02l6.4 15.33c-1.46.12-2.85.49-4.12 1.07zm9.93 23.18c-2.44-.03-4.74-.57-6.77-1.51-.28-.92-.42-1.88-.41-2.87.07-5.48 4.8-9.93 10.8-10.39l5.17 12.39c-2.5 1.52-5.52 2.42-8.79 2.38zm10.37-3.5-4.7-11.27c3.85.29 7.16 2.22 9.09 4.99-.79 2.45-2.33 4.61-4.39 6.28z" fill="currentColor"/></svg>` : ""}
            ${shop_data.アクティビティ_2 ? `<svg class="icon" enable-background="new 0 0 49.11 56.69" viewBox="0 0 49.11 56.69" xmlns="http://www.w3.org/2000/svg"><path d="m41.68 37.23 3.74-.55 2.1-1.73-2.69-.45-4.81 1.89-.05-.02-3.39-1.73 6.29-2.11 1.86-2.32-2.98-.07-3.37 2.03-5.14.78-.03-.02-2.8-1.43.87-.5.48-.68-.83.07-.74.42v-4.91l.74.42.83.07-.48-.68-.87-.5 2.84-1.45.04.01 5.15.79 3.32 2.01 2.97-.07-1.86-2.32-6.29-2.11 3.44-1.76.05.02 4.77 1.87 2.69-.45-2.1-1.73-3.74-.55 4.95-2.53 2.48-2.76-3.63.76-4.67 3.02 1.39-3.51-.45-2.69-1.74 2.1-.77 5.11-.06.03-3.19 2.07.06-.28 1.26-6.23-1.08-2.77-1.55 2.54.08 3.91-.01.02-1.9 4.84-2.67 1.73v-1l-.35-.76-.35.76v.85l-4.23-2.44.74-.42.48-.68-.83.07-.87.5.16-3.18.02-.03 3.25-4.06 3.4-1.87 1.43-2.61-2.94.45-4.98 4.39.2-3.85.04-.03 4-3.19.95-2.55-2.55.95-2.34 2.96.29-5.55-1.16-3.54-1.15 3.53.29 5.55-2.34-2.96-2.55-.95.95 2.55 4.04 3.23v.05l.19 3.8-.21-.19-4.77-4.2-2.94-.45 1.43 2.61 3.44 1.9 3.24 4.06v.04l.16 3.14-.87-.5-.83-.07.48.68.74.42-4.23 2.44v-.85l-.35-.76-.35.76v1l-2.67-1.73-.02-.04-1.89-4.85.08-3.88-1.55-2.54-1.08 2.77 1.31 6.51-3.24-2.1-.01-.05-.77-5.06-1.73-2.1-.45 2.69 1.39 3.51-4.67-3.02-3.62-.77 2.48 2.76 4.95 2.53-3.74.55-2.1 1.73 2.69.45 4.82-1.89 3.44 1.76-.27.09-6.02 2.02-1.86 2.32 2.97.07 3.37-2.03 5.14-.78.03.02 2.8 1.43-.87.5-.48.68.83-.07.74-.42v4.89l-.74-.42-.83-.07.48.68.87.5-2.84 1.45-.04-.01-5.15-.79-3.32-2.01-2.97.07 1.86 2.32 6.29 2.11-3.43 1.77-.05-.02-4.77-1.87-2.69.45 2.1 1.73 3.74.55-4.95 2.53-2.48 2.77 3.63-.76 4.67-3.02-1.39 3.51.45 2.69 1.73-2.1.77-5.11.05-.03 3.19-2.07-.06.28-1.26 6.23 1.08 2.77 1.55-2.54-.08-3.91.01-.02 1.9-4.84 2.67-1.73v1l.35.76.35-.76v-.87l4.23 2.44-.74.42-.48.68.83-.07.87-.5-.16 3.18-.02.03-3.25 4.06-3.4 1.87-1.43 2.61 2.94-.44 4.98-4.39-.2 3.85-.04.03-4 3.19-.95 2.55 2.55-.95 2.34-2.96-.29 5.55 1.16 3.53 1.15-3.53-.29-5.55 2.34 2.96 2.55.95-.95-2.55-4.04-3.23v-.05l-.19-3.8.21.19 4.76 4.2 2.94.45-1.43-2.61-3.44-1.9-3.24-4.06v-.04l-.16-3.14.87.5.83.07-.48-.68-.74-.42 4.25-2.44v.85l.35.76.35-.76v-1l2.67 1.73.02.04 1.89 4.85-.08 3.88 1.55 2.54 1.08-2.77-1.32-6.5.24.16 3 1.94.01.05.77 5.06 1.73 2.1.45-2.69-1.39-3.51 4.67 3.02 3.63.76-2.48-2.76zm-12.19-6.04-.06.04-4.87 2.81-4.93-2.85v-5.7l.06-.04 4.87-2.81 4.93 2.85z" fill="currentColor"/></svg>` : ""}
          </div>
      ` : ""}

      ${shop_data.支払い方法 ? `
        <div class="c-result-shopname__payment">
            <span>支払い方法</span>
            ${shop_data.支払い方法}
        </div>
        ` : ""
      }`;

    // 閉じるボタン押下時、ポップアップ非表示
    close_btn.addEventListener('click', () => {
      popup.classList.remove('active');
      overlay.classList.remove('active');
    });

    // オーバーレイ押下時、ポップアップ非表示
    overlay.addEventListener('click', () => {
      popup.classList.remove('active');
      overlay.classList.remove('active');
    });
  }else{
    alert("店舗情報の取得に失敗しました。")
  }
}

// 各Shop行を返す
const renderShopContent = (_data,_insert_label_bf,_insert_label_af) =>{
  const change_label_class = _insert_label_bf !== "" && _insert_label_bf !== _insert_label_af ? `class="c-result-shop__label-change"` : ``;
  return `
    <tr ${change_label_class ? change_label_class : ""}>
      <td class="c-result-shopname">
        <h3 class="c-result-shopname__title">${_data.店名}</h3>
        <div class="c-result-shopname__social-media">
        ${_data.ラベル ? `<span class="tag-flag${_data.ラベル === "アウトレット店" ? " c-tag--SIS" : _data.ラベル === "ディーラー" ? " c-tag--dealer":""}">${_data.ラベル}</span>` : ""}
        ${_data.インスタ ? `
          <a href="${_data.インスタ}" target="_blank" rel="noopener noreferrer">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-instagram" viewBox="0 0 512 512"><path d="M256 49.5c67.3 0 75.2.3 101.8 1.5 24.6 1.1 37.9 5.2 46.8 8.7 11.8 4.6 20.2 10 29 18.8s14.3 17.2 18.8 29c3.4 8.9 7.6 22.2 8.7 46.8 1.2 26.6 1.5 34.5 1.5 101.8s-.3 75.2-1.5 101.8c-1.1 24.6-5.2 37.9-8.7 46.8-4.6 11.8-10 20.2-18.8 29s-17.2 14.3-29 18.8c-8.9 3.4-22.2 7.6-46.8 8.7-26.6 1.2-34.5 1.5-101.8 1.5s-75.2-.3-101.8-1.5c-24.6-1.1-37.9-5.2-46.8-8.7-11.8-4.6-20.2-10-29-18.8s-14.3-17.2-18.8-29c-3.4-8.9-7.6-22.2-8.7-46.8-1.2-26.6-1.5-34.5-1.5-101.8s.3-75.2 1.5-101.8c1.1-24.6 5.2-37.9 8.7-46.8 4.6-11.8 10-20.2 18.8-29s17.2-14.3 29-18.8c8.9-3.4 22.2-7.6 46.8-8.7 26.6-1.3 34.5-1.5 101.8-1.5m0-45.4c-68.4 0-77 .3-103.9 1.5C125.3 6.8 107 11.1 91 17.3c-16.6 6.4-30.6 15.1-44.6 29.1-14 14-22.6 28.1-29.1 44.6-6.2 16-10.5 34.3-11.7 61.2C4.4 179 4.1 187.6 4.1 256s.3 77 1.5 103.9c1.2 26.8 5.5 45.1 11.7 61.2 6.4 16.6 15.1 30.6 29.1 44.6 14 14 28.1 22.6 44.6 29.1 16 6.2 34.3 10.5 61.2 11.7 26.9 1.2 35.4 1.5 103.9 1.5s77-.3 103.9-1.5c26.8-1.2 45.1-5.5 61.2-11.7 16.6-6.4 30.6-15.1 44.6-29.1 14-14 22.6-28.1 29.1-44.6 6.2-16 10.5-34.3 11.7-61.2 1.2-26.9 1.5-35.4 1.5-103.9s-.3-77-1.5-103.9c-1.2-26.8-5.5-45.1-11.7-61.2-6.4-16.6-15.1-30.6-29.1-44.6-14-14-28.1-22.6-44.6-29.1-16-6.2-34.3-10.5-61.2-11.7-27-1.1-35.6-1.4-104-1.4z"/><path d="M256 126.6c-71.4 0-129.4 57.9-129.4 129.4s58 129.4 129.4 129.4 129.4-58 129.4-129.4-58-129.4-129.4-129.4zm0 213.4c-46.4 0-84-37.6-84-84s37.6-84 84-84 84 37.6 84 84-37.6 84-84 84z"/><circle cx="390.5" cy="121.5" r="30.2"/></svg>
          </a>
          ` : ""}
        </div>
        ${_data.アクティビティ_1 || _data.アクティビティ_2 ? `
          <div class="c-result-shopname__activity">
            <span>取り扱い有り</span>
            ${_data.アクティビティ_1 ? `<svg class="icon" enable-background="new 0 0 56.69 47.9" viewBox="0 0 56.69 47.9" xmlns="http://www.w3.org/2000/svg"><path d="m45.04 24.91-6.1-14.61c.85.19 1.64.28 2.36.29 1.3.7 5.25 2.81 7.45 3.62.86.32 1.54.51 2.15.51.79 0 1.44-.34 2.18-1.17.53-.61 2.16-2.46.44-4.23-1.54-1.59-5.47-5.2-7.16-6.74-.08-.84-.19-1.62-.33-2.19-.59-1.22-5.11.72-7.21 1.7-1.54.72-9.04.94-10.47.94-1.43.01-8.94-.22-10.47-.94-2.1-.98-6.62-2.92-7.21-1.7-.13.57-.24 1.35-.33 2.19-1.69 1.54-5.62 5.15-7.16 6.74-1.71 1.77-.09 3.62.44 4.23.73.84 1.38 1.17 2.18 1.17.6 0 1.28-.19 2.15-.51 2.2-.82 6.15-2.92 7.45-3.62.72 0 1.51-.09 2.36-.29l-6.1 14.61c-7.2.67-11.62 4.92-11.66 12.02-.04 6.52 5.43 11.05 11.98 10.97 3.73-.05 7.03-1.62 9.18-4.05-.01.01-.02.03-.04.04 6.18-5.73 3.93-13.33-1.55-16.95l8.77-7.7 8.77 7.7c-5.48 3.62-7.73 11.21-1.55 16.95-.01-.01-.02-.03-.04-.04 2.14 2.42 5.45 4 9.18 4.05 6.55.08 12.02-4.45 11.98-10.97-.03-7.1-4.44-11.35-11.64-12.02zm1.41-17.04c.08-.72.1-1.68.07-2.7 1.9 1.75 4.55 4.2 5.71 5.4.28.29.56.58-.5 1.8-.58.66-.68.78-2.35.16-1.38-.51-3.57-1.6-5.25-2.48 1.19-.4 1.94-.95 2.32-2.18zm-39.14 4.66c-1.67.62-1.77.5-2.35-.16-1.07-1.22-.78-1.52-.5-1.8 1.16-1.2 3.8-3.65 5.71-5.4-.03 1.02-.01 1.98.07 2.7.37 1.23 1.13 1.78 2.32 2.18-1.68.88-3.87 1.97-5.25 2.48zm-5.53 19.26c1.93-2.77 5.24-4.7 9.09-4.99l-4.7 11.27c-2.07-1.67-3.61-3.83-4.39-6.28zm21.93 5.39c.01.99-.14 1.96-.41 2.87-2.03.94-4.33 1.48-6.77 1.51-3.27.04-6.29-.85-8.79-2.39l5.17-12.39c6.01.47 10.74 4.92 10.8 10.4zm2.76-18.79-8.65 7.6c-1.27-.57-2.66-.95-4.12-1.07l6.4-15.33c.76-.29 1.53-.63 2.3-1.02 1.54.24 2.87.39 4.07.48zm3.76 0v-9.35c1.2-.08 2.53-.23 4.07-.48.77.39 1.54.74 2.3 1.02l6.4 15.33c-1.46.12-2.85.49-4.12 1.07zm9.93 23.18c-2.44-.03-4.74-.57-6.77-1.51-.28-.92-.42-1.88-.41-2.87.07-5.48 4.8-9.93 10.8-10.39l5.17 12.39c-2.5 1.52-5.52 2.42-8.79 2.38zm10.37-3.5-4.7-11.27c3.85.29 7.16 2.22 9.09 4.99-.79 2.45-2.33 4.61-4.39 6.28z" fill="currentColor"/></svg>` : ""}
            ${_data.アクティビティ_2 ? `<svg class="icon" enable-background="new 0 0 49.11 56.69" viewBox="0 0 49.11 56.69" xmlns="http://www.w3.org/2000/svg"><path d="m41.68 37.23 3.74-.55 2.1-1.73-2.69-.45-4.81 1.89-.05-.02-3.39-1.73 6.29-2.11 1.86-2.32-2.98-.07-3.37 2.03-5.14.78-.03-.02-2.8-1.43.87-.5.48-.68-.83.07-.74.42v-4.91l.74.42.83.07-.48-.68-.87-.5 2.84-1.45.04.01 5.15.79 3.32 2.01 2.97-.07-1.86-2.32-6.29-2.11 3.44-1.76.05.02 4.77 1.87 2.69-.45-2.1-1.73-3.74-.55 4.95-2.53 2.48-2.76-3.63.76-4.67 3.02 1.39-3.51-.45-2.69-1.74 2.1-.77 5.11-.06.03-3.19 2.07.06-.28 1.26-6.23-1.08-2.77-1.55 2.54.08 3.91-.01.02-1.9 4.84-2.67 1.73v-1l-.35-.76-.35.76v.85l-4.23-2.44.74-.42.48-.68-.83.07-.87.5.16-3.18.02-.03 3.25-4.06 3.4-1.87 1.43-2.61-2.94.45-4.98 4.39.2-3.85.04-.03 4-3.19.95-2.55-2.55.95-2.34 2.96.29-5.55-1.16-3.54-1.15 3.53.29 5.55-2.34-2.96-2.55-.95.95 2.55 4.04 3.23v.05l.19 3.8-.21-.19-4.77-4.2-2.94-.45 1.43 2.61 3.44 1.9 3.24 4.06v.04l.16 3.14-.87-.5-.83-.07.48.68.74.42-4.23 2.44v-.85l-.35-.76-.35.76v1l-2.67-1.73-.02-.04-1.89-4.85.08-3.88-1.55-2.54-1.08 2.77 1.31 6.51-3.24-2.1-.01-.05-.77-5.06-1.73-2.1-.45 2.69 1.39 3.51-4.67-3.02-3.62-.77 2.48 2.76 4.95 2.53-3.74.55-2.1 1.73 2.69.45 4.82-1.89 3.44 1.76-.27.09-6.02 2.02-1.86 2.32 2.97.07 3.37-2.03 5.14-.78.03.02 2.8 1.43-.87.5-.48.68.83-.07.74-.42v4.89l-.74-.42-.83-.07.48.68.87.5-2.84 1.45-.04-.01-5.15-.79-3.32-2.01-2.97.07 1.86 2.32 6.29 2.11-3.43 1.77-.05-.02-4.77-1.87-2.69.45 2.1 1.73 3.74.55-4.95 2.53-2.48 2.77 3.63-.76 4.67-3.02-1.39 3.51.45 2.69 1.73-2.1.77-5.11.05-.03 3.19-2.07-.06.28-1.26 6.23 1.08 2.77 1.55-2.54-.08-3.91.01-.02 1.9-4.84 2.67-1.73v1l.35.76.35-.76v-.87l4.23 2.44-.74.42-.48.68.83-.07.87-.5-.16 3.18-.02.03-3.25 4.06-3.4 1.87-1.43 2.61 2.94-.44 4.98-4.39-.2 3.85-.04.03-4 3.19-.95 2.55 2.55-.95 2.34-2.96-.29 5.55 1.16 3.53 1.15-3.53-.29-5.55 2.34 2.96 2.55.95-.95-2.55-4.04-3.23v-.05l-.19-3.8.21.19 4.76 4.2 2.94.45-1.43-2.61-3.44-1.9-3.24-4.06v-.04l-.16-3.14.87.5.83.07-.48-.68-.74-.42 4.25-2.44v.85l.35.76.35-.76v-1l2.67 1.73.02.04 1.89 4.85-.08 3.88 1.55 2.54 1.08-2.77-1.32-6.5.24.16 3 1.94.01.05.77 5.06 1.73 2.1.45-2.69-1.39-3.51 4.67 3.02 3.63.76-2.48-2.76zm-12.19-6.04-.06.04-4.87 2.81-4.93-2.85v-5.7l.06-.04 4.87-2.81 4.93 2.85z" fill="currentColor"/></svg>` : ""}
          </div>
        ` : ""}
      </td>
      <td class="c-result-shopdesc">
        <div class="c-result-shopdesc__content">
          <div class="c-result-shopdesc__content-desc">
            <p>${_data.住所.charAt(0) === "〒" ? _data.住所.replace(" ","<br/>") : _data.住所}</p>
            <p>${_data.電話番号}</p>
            ${ _data.営業時間 || _data.GoogleMap_リンク ?
             `<p>
                ${_data.営業時間 ? `<span class="c-result-shopdesc__business-hour">営業時間：${_data.営業時間}</span>` : ""}
                ${_data.GoogleMap_リンク ? `<a href="${_data.GoogleMap_リンク}" target="_blank" rel="noopener noreferrer" class="c-result-shopdesc__link medium-up--hide">地図を見る</a>` : ""}
              </p>
              ` : ""
            }
          </div>
          ${ _data.GoogleMap_埋め込み ? `
              <div class="c-result-shopdesc__content-link small--hide">
                <a href="javascript:void(0)" onclick="openMapPopup(event,'${_data.データ番号}','${_data.カテゴリー}')" class="c-result-shopdesc__link">詳細を見る</a>
              </div>
            ` : ""
            }
        </div>
      </td>
    </tr>
  `;
}

// 各都市の検索機能
const searchFunc = (e)=>{
  const selected_province = e.target.dataset.value;
  const selected_province_major_city = e.target.dataset.province_major_region;
  const category = e.target.dataset.category;
  const clear_condition_flg = e.target.classList.contains("is-active");
  const shop_data = category === "veilance" ? fetch_shop_data_veilance : fetch_shop_data_outdoor;
  const shoplist_result = document.querySelector(`#c-content-${category} .c-shoplist-result`);

  console.log(selected_province);

  shoplist_result.innerHTML = "";
  if(shop_data){
    //取得結果が0件でなければ、検索処理を開始
    let searched_data = {};

    if(clear_condition_flg === false){
      // 検索条件がある場合、データを抽出して設定
      // 条件：都市が選択した県に一致 or 主要都市がある場合は主要都市も対象
      // selected_province = 東京(23区)の場合、data.都市 === 東京のデータを抽出
      // selected_province = 東京(23区以外)の場合、data.都市 === 東京都のデータを抽出
      if(selected_province === "東京(23区)"){
        searched_data = shop_data.filter(data => data.都市 === "東京");
      }else if(selected_province === "東京(23区以外)"){
        searched_data = shop_data.filter(data => data.都市 === "東京都");
      }else{
        searched_data = shop_data.filter(data => data.都市 === selected_province || (selected_province_major_city && data.都市 === selected_province_major_city));
      }
    }else{
      // 検索条件がない場合、全データを設定
      searched_data = shop_data;
    }

    let insert_elem = "",
      insert_label_bf = "",
      insert_label_af = "";
    if(searched_data.length > 0){
      // 検索結果が0件でなければ、検索結果を表示
      //ヘッダー追加
      shoplist_result.insertAdjacentHTML('beforeend',`
        <tr>
          <th class="c-result-shopname c-shoplist__content-heading">店名</th>
          <th class="c-result-shopdesc c-shoplist__content-heading">詳細</th>
        </tr>
      `);
      searched_data.forEach((data)=>{
        insert_label_af = data.ラベル;
        insert_elem = renderShopContent(data,insert_label_bf,insert_label_af);
        shoplist_result.insertAdjacentHTML('beforeend',insert_elem);
        insert_label_bf = data.ラベル;
      });
    }else{
      //検索結果が0件ならば
      shoplist_result.insertAdjacentHTML('beforeend',`
      <tr>
        <th class="c-result-shopname c-shoplist__content-heading">この地域に販売店はありません。</th>
      </tr>
      `);
    }
    
    // // ダイアログ通知
    // document.querySelector('.c-search-announce-dialog__wrapper').classList.add("is-open");
    // setTimeout(()=>{
    //   document.querySelector('.c-search-announce-dialog__wrapper').classList.remove("is-open")
    // },3000);
  }

  // is-active変更処理
  document.querySelector(`#c-content-${category} .c-shoplist-province__item-heading.is-active`)?.classList.remove('is-active');
  document.querySelector(`#c-content-${category} .c-shoplist-province__item-name.is-active`)?.classList.remove('is-active');
  if(clear_condition_flg === false){
    // 新しく都市を選択した場合、有効化表示
    e.target.classList.add('is-active');
    document.getElementById(e.target.dataset.region_id).classList.add('is-active');
  }
}

// 初期表示
window.addEventListener('DOMContentLoaded', () => {
  // URLパラメータからタブを初期化
  initTabFromUrl();
  
  const shoplist_group = document.getElementById("c-content-group");
  const shoplist_result_outdoor = document.querySelector('#c-content-outdoor .c-shoplist-result'),
    shoplist_result_veilance = document.querySelector('#c-content-veilance .c-shoplist-result')

  //初期処理用関数
  const initializeShopList = (_fetch_data)=>{
    fetch_shop_data_outdoor = _fetch_data.filter(data => data.カテゴリー === "OUTDOOR" || data.カテゴリー === "OUTDOOR_VEILANCE");
    fetch_shop_data_veilance = _fetch_data.filter(data => data.カテゴリー === "VEILANCE" || data.カテゴリー === "OUTDOOR_VEILANCE");

    //イベント一覧表示
    let insert_elem = "",
      insert_label_bf = "",
      insert_label_af = "";
    // OUTDOOR
    if(fetch_shop_data_outdoor.length > 0){
      //ヘッダー追加
      shoplist_result_outdoor.insertAdjacentHTML('beforeend',`
        <tr>
          <th class="c-result-shopname c-shoplist__content-heading">店名</th>
          <th class="c-result-shopdesc c-shoplist__content-heading">詳細</th>
        </tr>
      `);

      fetch_shop_data_outdoor.forEach((data)=>{
        insert_label_af = data.ラベル;
        insert_elem = renderShopContent(data,insert_label_bf,insert_label_af);
        shoplist_result_outdoor.insertAdjacentHTML('beforeend',insert_elem);
        insert_label_bf = data.ラベル;
      });
    }
    // VEILANCE
    insert_elem = "",
      insert_label_bf = "",
      insert_label_af = "";
    if(fetch_shop_data_veilance.length > 0){
      //ヘッダー追加
      shoplist_result_veilance.insertAdjacentHTML('beforeend',`
        <tr>
          <th class="c-result-shopname c-shoplist__content-heading">店名</th>
          <th class="c-result-shopdesc c-shoplist__content-heading">詳細</th>
        </tr>
      `);

      fetch_shop_data_veilance.forEach((data)=>{
        insert_label_af = data.ラベル;
        insert_elem = renderShopContent(data,insert_label_bf,insert_label_af);
        shoplist_result_veilance.insertAdjacentHTML('beforeend',insert_elem);
        insert_label_bf = data.ラベル;
      });
    }

    // 各都市elemに検索機能を付与
    document.querySelectorAll('.c-shoplist-province__item-name').forEach(elem => {
      elem.addEventListener('click', searchFunc);
    });
  }

  //[assets]フォルダ > "shop-list.json"から情報を取得
  const requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };
  const fetch_url = shoplist_group.dataset.shoplist;
  fetch(fetch_url, requestOptions)
    .then(response => response.json())
    .then(result => initializeShopList(result))
    .catch(error => console.error(error));
});